import React from 'react'
import CommentItem from './commentItem'

const CommentList = ({comments, RefreshComment, setReplyto}) => {
  return (
    <div className='comments_list_container'>
      {
        comments.map((item,index)=>{
            return(
                <CommentItem key={index} Comment={item} RefreshComment={RefreshComment} setReplyto={setReplyto}/>
            )
        })
      }
    </div>
  )
}

export default CommentList
